import { createAction } from 'redux-actions'

const prefix = 'Appnexus:'
export const UPDATE_APN_TAG_READY = `${prefix}: Update apn tag ready.`

const updateApnTagReady = createAction(UPDATE_APN_TAG_READY)

export const actionCreators = {
  updateApnTagReady,
}
